import React, { Fragment } from 'react';

interface ShipToSuccessProps {
  submit: () => void;
}

const ShipToSuccess: React.FC<ShipToSuccessProps> = ({ submit }) => {
  return (
    <div className="flex flex-col p-6 sm:p-10">
      <div className="flex justify-center">
        <div className="w-16 h-16 sm:w-24 sm:h-24 flex items-center justify-center">
          <img
            src="/tada.gif"
            alt="Party Popper"
            className="w-16 h-16 sm:w-24 sm:h-24"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.onerror = null;
              target.innerHTML = '🎉';
            }}
          />
        </div>
      </div>
      <div className="bg-white max-w-lg font-sofiaSans">
        <div className="text-start">
          <h2 className="text-xl sm:text-2xl font-bold text-center text-black mb-3 sm:mb-5">
            Your Class Shipment Is on Its Way!
          </h2>
          <div className="mt-2">
            <p className="text-sm text-gray-600 leading-relaxed px-2 mb-3">
              Your class's paid books are being printed and will arrive at your school in one box.
            </p>
            <p className="text-sm text-gray-600 leading-relaxed px-2 mb-3">
              📦 Estimated delivery: <span className="font-bold">up to 10 business days</span>
            </p>
            <p className="text-sm text-gray-600 leading-relaxed px-2 mb-4">
              From now on, any new orders from families ship directly to their own address — you don't need to do
              anything else. Thanks for helping your students become published authors!
            </p>
          </div>
        </div>
      </div>
      <div className="bg-white py-2 flex justify-center sm:justify-end items-center mt-6">
        <button
          className={`px-6 py-2 h-9 bg-secondaryStoryAdditionalLightBlueText text-whiteText font-bold leading-none rounded-2xl hover:shadow-md transition-shadow flex items-center w-full sm:w-auto justify-center text-sm sm:text-base`}
          onClick={() => submit()}
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default ShipToSuccess;
